import { useState } from "react";
import { apiFetch } from "../lib/api";

interface Props {
  onLogin: (key: string) => void;
}

export default function LoginPage({ onLogin }: Props) {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);

  // 即場驗證（2026-09-17）：錯 key 立刻報錯，唔會「入到去先爆 Unauthorized」
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (key.trim().length < 1) {
      setError("請輸入 ADMIN_API_KEY");
      return;
    }
    setError("");
    setChecking(true);
    try {
      // 暫存 key 打一個輕量端點驗真——401＝無效
      localStorage.setItem("admin_key", key.trim());
      const res = await apiFetch("/admin/onboard-count");
      if (res.status === 401) {
        localStorage.removeItem("admin_key");
        setError("管理員密鑰無效——請核對最新一條（見 ADMIN_CREDENTIALS*.txt）");
        setChecking(false);
        return;
      }
    } catch {
      // 網絡錯誤唔阻登入（入去重試）
    }
    setChecking(false);
    onLogin(key.trim());
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <div className="w-full max-w-md p-8 bg-slate-900 rounded-xl border border-slate-700 shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-emerald-400 mb-2">
            🤖 AI Bot Admin
          </h1>
          <p className="text-slate-400 text-sm">多租戶 AI 知識庫管理後台</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">
              ADMIN_API_KEY
            </label>
            <input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="輸入您的管理員密鑰"
              className="w-full px-4 py-2 bg-slate-800 border border-slate-600 rounded-lg text-slate-100 placeholder-slate-500 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"
            />
          </div>

          {error && (
            <div className="text-rose-400 text-sm">{error}</div>
          )}

          <button
            type="submit"
            disabled={checking}
            className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white font-medium rounded-lg transition-colors"
          >
            {checking ? "驗證中…" : "登入"}
          </button>
          {/* 2026-10-27：舊金鑰 401 循環實錄——提示核對最新一條，避免重複輸入同一支舊 key */}
          <p className="text-xs text-slate-500 text-center leading-relaxed">
            若登入後不久被自動登出＝金鑰已失效，請核對 ADMIN_CREDENTIALS*.txt<b>最新一條</b>再輸入。
          </p>
        </form>
      </div>
    </div>
  );
}
